module.exports = __webpack_public_path__ + "img/bicycle-green-left.c2b08a9a.jpg";